export const USERS_INFO = 'USERS_INFO';
export const USERS_INFO_SUCCESS = 'USERS_INFO_SUCCESS';
export const USERS_INFO_FAILED = 'USERS_INFO_FAILED';

export const RESET_USERS = 'RESET_USERS';
